import { EmailTypes } from "../types/EmailTypes";
import { JobOfferForm } from "../classes/JobOfferForm";
import { GACategoryTypes } from "../types/GACategoryTypes";
import { GA } from "../classes/GA";
import { GAEventTypes } from "../types/GAEventTypes";

export class CareerPage {

  _careerFormEl;

  init() {
    this._careerFormEl = document.querySelector('#applyForJobForm');

    if (this._careerFormEl) {
      this.careerFormActions();
    }

    return this;
  }

  careerFormActions() {
    if (window['areCookiesPreferencesSet'] && window['cookiesPreferences'].analyticsCookie) {
      GA.gaLoaded(ga => {
        ga(
          'send',
          'event',
          GACategoryTypes.JobOffers,
          this._careerFormEl.querySelector('input[name="subject"]').value
        );
      });

      dataLayer.push({ 'event': `cc_${GACategoryTypes.JobOffers}_${GAEventTypes.ContactSend}` });
    }

    const form = new JobOfferForm(
      this._careerFormEl,
      EmailTypes.JobApplication,
      GACategoryTypes.TrackingContactUs,
      this._careerFormEl.querySelector('input[name="subject"]').value
    );

    form.init();
  }
}
